export enum Language {
  Fr,
  En,
}

export interface UserSettings {
  language: Language;
}
